import { api } from "./client";
import type { Page } from "./hits";

export interface Report {
  id: number;
  tipo: string;
  formato: string;
  parametrosJson: Record<string, unknown>;
  estado: string;
  errorMensaje: string | null;
  solicitadoAt: string;
  terminadoAt: string | null;
  archivoId: number | null;
}

export async function generateReport(body: {
  tipo: string;
  formato: string;
  parametros?: Record<string, unknown>;
}): Promise<Report> {
  const res = await api.post<Report>("/reports", body);
  return res.data;
}

export async function listReports(): Promise<Page<Report>> {
  const res = await api.get<Page<Report>>("/reports");
  return res.data;
}

export async function getReport(id: number): Promise<Report> {
  const res = await api.get<Report>(`/reports/${id}`);
  return res.data;
}

export async function downloadReport(
  id: number
): Promise<{ url: string; expiresAt: string; mimeType: string; bytesSize: number }> {
  const res = await api.get(`/reports/${id}/download`);
  return res.data;
}
